/* eslint-disable react-refresh/only-export-components */
import { lazy, Suspense, useCallback, useMemo, useState } from 'react';
import { EscalationHistoryPanelContext } from './escalationHistoryPanelContext';

const EscalationHistorySlidePanelLazy = lazy(() =>
  import('../components/EscalationHistorySlidePanel').then((m) => ({
    default: m.EscalationHistorySlidePanel,
  })),
);

export function EscalationHistoryProvider({ children }) {
  const [isPanelOpen, setPanelOpen] = useState(false);

  const openPanel = useCallback(() => setPanelOpen(true), []);
  const closePanel = useCallback(() => setPanelOpen(false), []);
  const togglePanel = useCallback(() => setPanelOpen((open) => !open), []);

  const value = useMemo(
    () => ({
      isPanelOpen,
      setPanelOpen,
      openPanel,
      closePanel,
      togglePanel,
    }),
    [isPanelOpen, openPanel, closePanel, togglePanel],
  );

  return (
    <EscalationHistoryPanelContext.Provider value={value}>
      {children}
      <Suspense fallback={null}>
        <EscalationHistorySlidePanelLazy />
      </Suspense>
    </EscalationHistoryPanelContext.Provider>
  );
}

export {
  useEscalationHistoryPanel,
  useEscalationHistoryPanelOptional,
} from './escalationHistoryPanelContext';
